import {
    FieldInCard,
} from 'app/types/form.types'

import {
    ContainerLocationChangeNote,
} from '../../../ContainerNotes.types'
import {
    AuditTrailConfig, getChangeConfig,
} from './notesConfigs'

type Fields = keyof ContainerLocationChangeNote

const locationFields: FieldInCard<Fields>[] = [
    getChangeConfig({
        showOrder: true,
        removeAttachmentsField: true,
    }),
    {
        title: 'Location Old',
        className: 'locationOld',
        fields: [{
            name: 'locationChange',
            labelKey: 'Note.containerLocationChange',
            componentName: 'LocationChangeSelector',
            inputs: ['old'],
        }],
    },
    {
        title: 'Location New',
        className: 'locationNew',
        fields: [{
            name: 'locationChange',
            labelKey: 'Note.containerLocationChange',
            componentName: 'LocationChangeSelector',
            inputs: ['actual'],
        }],
    },
    AuditTrailConfig,
]

export default locationFields
